import { render } from "./EnvironmentBanner.vue?vue&type=template&id=1d3e286d&scoped=true"
import script from "./EnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./EnvironmentBanner.vue?vue&type=script&lang=js"

import "./EnvironmentBanner.vue?vue&type=style&index=0&id=1d3e286d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3e286d"]])

export default __exports__